import { useEffect, useState } from "react";

import { useDashboardActions } from "../../../lib/useDashboardActions";
import { useWorkspace } from "@/features/Workspace/lib/useWorkspace";
import { useDashboard } from "../../../lib/useDashboard";
import { useAuth } from "@/features/Auth/lib/useAuth";
import { usePlan } from "@/entities/Plan";
import { generateRandomHash } from "@/shared/lib/hash";
import { getDisplayEmployees, TopUsersInterface } from "../TopEmployeesCompany/useTopEmployeesCompany";
import { getInitialBoolean, getInitialNumber } from "@/shared/lib/localStorage";

const useTopEmployeesDepartment = (depatrmentId: string | null) => {
  const { isAuth, user } = useAuth();
  const { users } = useWorkspace();
  const { planTypes, loading: planLoading } = usePlan();

  const { loading: dashboardLoading, error, dateStart, dateEnd, dashboardTopEmployeesDepartment: emps, setDashboardTopEmployeesDepartment } = useDashboard();
  const { getTopEmployees } = useDashboardActions();

  const departmentIdForRequest =
    depatrmentId != null && depatrmentId !== ""
      ? Number(depatrmentId)
      : user?.bx?.department?.[0]?.id;

  // --- localStorage keys ---
  const LS_IS_PERIOD_KEY = 'topEmployeesDepartment_isPeriod';
  const LS_TYPE_ID_KEY = 'topEmployeesDepartment_typeId';

  const [isPeriod, setIsPeriodState] = useState<boolean>(getInitialBoolean(LS_IS_PERIOD_KEY, false));
  const [typeId, setTypeIdState] = useState<number>(getInitialNumber(LS_TYPE_ID_KEY, 4));
  const [compEmp, setCompEmp] = useState<TopUsersInterface[]>([]);

  // Получение данных (у менеджера selectedDepartment пустой — подставляем отдел из user.bx.department)
  useEffect(() => {
    if (isAuth && dateStart && dateEnd && departmentIdForRequest != null) {
      getTopEmployees({
        dateStart,
        dateEnd,
        isPeriod,
        typeId,
        departmentId: departmentIdForRequest,
      }).then((result) => {
        setDashboardTopEmployeesDepartment(result);
      });
    }
    // eslint-disable-next-line
  }, [isAuth, dateStart, dateEnd, isPeriod, typeId, depatrmentId, departmentIdForRequest]);

  // --- эффекты для записи в localStorage ---
  useEffect(() => {
    localStorage.setItem(LS_IS_PERIOD_KEY, String(isPeriod));
  }, [isPeriod]);
  useEffect(() => {
    localStorage.setItem(LS_TYPE_ID_KEY, String(typeId));
  }, [typeId]);

  // Сообщение при отсутствии данных
  let fullMessage: string | undefined = undefined;
  if (!dashboardLoading.dashboardTopEmployees && emps.length === 0) {
    const planObject = planTypes.find((pt) => pt.id === typeId)?.plan_object;
    if (planObject) {
      fullMessage = `Нет планов "${planObject}" или сотрудников`;
    } else {
      fullMessage = "Нет планов, продаж или сотрудников";
    }
  }

  // Формируем топ 5 для карточки
  useEffect(() => {
    if (emps.length > 0) {
      const us = emps
        .map((u) => {
          const userData = users.find((_u) => _u.id === u.id);
          return {
            ...u,
            name: `${userData?.name || ""}`,
            fullName: `${userData?.name || ""} ${userData?.last_name || ""}`,
            photoUrl: userData?.personal_photo || "",
          } as TopUsersInterface;
        });
      setCompEmp(us);
    }
    // eslint-disable-next-line
  }, [users, emps]);

  let { top, current } = getDisplayEmployees(compEmp, user?.bx.bx_user.bx_id);

  const emptyCount = 5 - top.length - (current ? 1 : 0);
  if (emptyCount > 0 ) {
    top = [
      ...top,
      ...Array.from({ length: emptyCount }, (_, i) => ({
        id: -(i + 1),
        name: '',
        fullName: '',
        photoUrl: `https://gravatar.com/avatar/${generateRandomHash()}?s=400&d=monsterid&r=x`,
        place: top.length + i + 1,
        percent: 0,
        placeDiff: 0,
        isEmpty: true
      }))
    ];
  }

  // --- экспортируемые сеттеры ---
  return {
    top5: top,
    top: compEmp,
    loading: dashboardLoading.dashboardTopEmployees || planLoading.planTypes,
    error: error.dashboardTopEmployees,
    fullMessage,
    current: current ? current : null,
    currentUserId: user?.bx.bx_user.bx_id,

    // for popup
    planTypes,
    isPeriod,
    setIsPeriod: setIsPeriodState,
    typeId,
    setTypeId: setTypeIdState,
  }
}

export default useTopEmployeesDepartment;